export default function CustomerFavorite() {

  return (
      <p>علاقمندی ها</p>
  );
};